import React, { useState, useEffect, useRef } from "react";

import bg from "assests/About/awards/bg.jpg";

const Certifications = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return (
    <section
      ref={sectionRef}
      className="scroll-section  relative background flex flex-col items-center justify-center z-[10]"
    >
      <div className="absolute w-full h-full inset-0 z-[2]">
        <img src={bg} alt="" />
      </div>
      <div className="absolute left-1/2  -translate-x-1/2 top-20 z-[2]">
        <h1 className="text-font text-7xl sm:text-8xl lg:text-[9.2rem] bebas text-white opacity-50 ">
          certification
        </h1>
      </div>

      <div
        className={`grid w-3/4 mx-auto grid-cols-1 lg:grid-cols-2 gap-y-10 lg:gap-y-0 lg:flex-row py-44 justify-center items-center gap-x-32  relative z-[2] transition ease-in duration-500  ${
          visible
            ? "scale-[1] opacity-[1] translate-y-[0%]"
            : "scale-50 opacity-0 translate-y-[40%]"
        }`}
      >
        {data?.data.map(({ image, text }, index) => (
          <div
            key={index}
            className={`lg:w-[75%] lg:mx-auto transition ease-in duration-300 opacity-[0.7] hover:opacity-[1] ${
              index % 2 !== 0 ? "lg:translate-y-[30%]" : ""
            }`}
          >
            <img className="mx-auto min-h-[300px]" src={image} alt="" />
            <p className="text-white text-lg mt-2 capitalize">{text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
